module.exports = __webpack_public_path__ + "media/images/transformers-2-9c1a330ee6494bc22aedc6023cc7918d.jpg";